import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, ChevronRight } from "lucide-react";
import { RevealLines, Reveal } from "@/components/Reveal";

export const PageHero = ({ eyebrow, titleLines, text, image, breadcrumb }) => (
  <section className="relative overflow-hidden bg-[#17251C] pb-24 pt-40 md:pb-32 md:pt-52">
    {image && (
      <motion.img
        src={image}
        alt=""
        aria-hidden="true"
        initial={{ opacity: 0, scale: 1.08 }}
        animate={{ opacity: 0.42, scale: 1 }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 h-full w-full object-cover"
      />
    )}
    <div className="absolute inset-0 bg-gradient-to-r from-[#17251C] via-[#17251C]/82 to-[#17251C]/35" />

    <svg viewBox="0 0 1200 400" className="pointer-events-none absolute inset-x-0 bottom-0 h-40 w-full" aria-hidden="true">
      <motion.path
        d="M-20 320C240 250 420 350 660 280 880 214 1000 300 1220 240"
        fill="none"
        stroke="#DCCDB4"
        strokeWidth="1"
        strokeOpacity="0.35"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 2.2, ease: "easeInOut", delay: 0.4 }}
      />
    </svg>

    <div className="relative mx-auto max-w-[1480px] px-5 md:px-10">
      <nav className="mb-8 flex items-center gap-2 text-[0.62rem] font-bold uppercase tracking-[0.24em] text-[#93A387]">
        <Link to="/" className="transition-colors hover:text-[#F3EDE2]">
          Garten
        </Link>
        <ChevronRight size={11} />
        <span className="text-[#DCCDB4]">{breadcrumb}</span>
      </nav>
      <p className="eyebrow !text-[#DCCDB4]">{eyebrow}</p>
      <RevealLines
        lines={titleLines}
        onLoad
        delay={0.15}
        className="display-xl mt-5 max-w-4xl text-[12vw] leading-[0.9] text-[#F3EDE2] md:text-[5.6vw]"
      />
      <Reveal delay={0.5}>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#DCCDB4] md:text-lg">{text}</p>
        <Link to="/kontakt" className="btn-primary mt-10 !bg-[#F3EDE2] !text-[#17251C]" data-testid="pagehero-cta">
          Kostenlose Beratung <ArrowUpRight size={15} />
        </Link>
      </Reveal>
    </div>
  </section>
);
